// extracted by mini-css-extract-plugin
export default {"reinstate_container":"ReinstateiItem_reinstate_container__1CprM","reinstate_container_inner":"ReinstateiItem_reinstate_container_inner__SBN4u"};